import React, { useState, useEffect } from "react";
import { gql, useApolloClient } from "@apollo/client";
import Header from "../components/Header";
import Footer from "../components/Footer";
import "../styles/MesDeclarations.css";

const GET_DECLARATION_BY_PHONE = gql`
  query GetDeclarationByPhone($telephone: String!) {
    carte_identite_perdue(where: { telephone: { _eq: $telephone } }) {
      id etat
    }
    carte_etudiant_perdue(where: { telephone: { _eq: $telephone } }) {
      id etat
    }
    passeport_perdu(where: { telephone: { _eq: $telephone } }) {
      id etat
    }
    permis_perdu(where: { telephone: { _eq: $telephone } }) {
      id etat
    }
    carte_commerce_perdue(where: { telephone: { _eq: $telephone } }) {
      id etat
    }
    carte_professionnelle_perdue(where: { telephone: { _eq: $telephone } }) {
      id etat
    }

    carteidentiteramassee(where: { telephone: { _eq: $telephone } }) {
      id etat
    }
    carteetudiantramassee(where: { telephone: { _eq: $telephone } }) {
      id etat
    }
    passeportramasse(where: { telephone: { _eq: $telephone } }) {
      id etat
    }
    permisramasse(where: { telephone: { _eq: $telephone } }) {
      id etat
    }
    cartecommerceramassee(where: { telephone: { _eq: $telephone } }) {
      id etat
    }
    carteprofessionnelleramassee(where: { telephone: { _eq: $telephone } }) {
      id etat
    }
  }
`;

const MesDeclarations = () => {
  const client = useApolloClient();
  const [phoneNumber, setPhoneNumber] = useState("");
  const [declarations, setDeclarations] = useState([]);
  const [alertMessage, setAlertMessage] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const fetchDeclarations = async () => {
      if (phoneNumber.length !== 9) {
        setDeclarations([]);
        setAlertMessage("");
        return;
      }

      setLoading(true);
      try {
        const { data } = await client.query({
          query: GET_DECLARATION_BY_PHONE,
          variables: { telephone: phoneNumber },
          fetchPolicy: "network-only",
        });

        const mappedResults = Object.entries(data).flatMap(([key, items]) =>
          (items || []).map(item => ({
            id: item.id,
            etat:
              key.toLowerCase().includes("perdue") ? "Perdu" :
              key.toLowerCase().includes("ramasse") ? "Ramassé" :
              item.etat,
            categorie:
              key.toLowerCase().includes("identite") ? "Carte d'identité" :
              key.toLowerCase().includes("etudiant") ? "Carte d'étudiant" :
              key.toLowerCase().includes("passeport") ? "Passeport" :
              key.toLowerCase().includes("permis") ? "Permis de conduire" :
              key.toLowerCase().includes("commerce") ? "Carte de commerce" :
              key.toLowerCase().includes("professionnelle") ? "Carte professionnelle" :
              "Document inconnu",
          }))
        );

        const uniqueResults = mappedResults.filter(
          (item, index, self) => index === self.findIndex(t => t.id === item.id)
        );

        if (uniqueResults.length > 0) {
          setDeclarations(uniqueResults);
          setAlertMessage("");
        } else {
          setDeclarations([]);
          setAlertMessage("❌ Ce numéro n’a encore aucune déclaration enregistrée.");
        }
      } catch (err) {
        console.error("Erreur Hasura :", err);
        setAlertMessage("⚠️ Erreur de connexion au serveur Hasura.");
        setDeclarations([]);
      } finally {
        setLoading(false);
      }
    };

    fetchDeclarations();
  }, [phoneNumber, client]);

  const handleChange = e => {
    const value = e.target.value;
    if (/^\d*$/.test(value)) setPhoneNumber(value);
  };

  return (
    <div className="mes-declarations-container">
      <Header />
      <main className="mes-declarations-content">
        <div className="mes-declarations-card">
          <h1>Mes Déclarations</h1>
          <p>Entrez le numéro de téléphone utilisé lors de votre déclaration :</p>

          <label htmlFor="phone-number">Numéro de téléphone</label>
          <input
            id="phone-number"
            type="text"
            placeholder="Ex : 770000000"
            value={phoneNumber}
            onChange={handleChange}
            maxLength={9}
          />

          {loading && <p style={{ color: "blue", marginTop: "10px" }}>🔍 Vérification en cours...</p>}

          {alertMessage && !loading && <div style={{ color: "red", marginTop: "10px" }}>{alertMessage}</div>}

          {declarations.length > 0 && (
            <div className="mes-declarations-details" style={{ marginTop: "20px" }}>
              <h2>📋 Détails des déclarations :</h2>

              {declarations.map(decl => (
                <div
                  key={decl.id}
                  className="declaration-item"
                  style={{
                    border: "1px solid #ddd",
                    borderRadius: "10px",
                    padding: "15px",
                    marginBottom: "15px",
                    backgroundColor: decl.etat === "Perdu" ? "#ffe5e5" : "#e5ffe5",
                  }}
                >
                  <h3>💳 {decl.categorie}</h3>
                  <p><strong>État :</strong> {decl.etat}</p>
                </div>
              ))}
            </div>
          )}
        </div>
      </main>
      <Footer />
    </div>
  );
};

export default MesDeclarations;